import React, { Component } from "react";
import { Card, CardBody, Alert, Col, Row } from "reactstrap";
import { connect } from "react-redux";
import { metadataService } from "../_services";
import { BsTools } from "react-icons/bs";

class Maintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="justify-content-center text-center mt-5 pt-5">
            <Alert
              color="danger"
              className="text-center"
            >
              <Row>
                <Col className="text-center p-3">
                  <BsTools size={100} />
                </Col>
              </Row>
              <h6 className="p-3">
              {metadataService.getMessage("Maintenance")}
              </h6>
            </Alert>
        <Row>
          <Col>
          </Col>
        </Row>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

const connectedMaintenance = connect(mapStateToProps)(Maintenance);
export { connectedMaintenance as Maintenance };
